import api from "./api";

export const getTransactions = (params) =>
  api.get("/transactions", { params });

export const getTransactionDetail = (transactionId) =>
  api.get(`/transactions/${transactionId}`);
